import React from "react";
import iconUser from "../../assets/homepage/body/user.png";
import iconTick from "../../assets/homepage/body/tick.png";
import iconInfo from "../../assets/homepage/body/thongtinkm.png";
const RegistrationForm = ({
  username,
  setUsername,
  captcha,
  setCaptcha,
  captchaSvg,
  fetchCaptcha,
  checkUsername,
  titleNotify,
}) => {
  return (
    <div className="w-full max-w-3xl mx-auto mt-2 md:mt-3">
      
      {/* <div className="flex justify-center mb-3">
        <h1
          className="uppercase text-center px-4 pb-2"
          style={{
            color: "#00ADEE",
            fontFamily: "SVN-Aptima, sans-serif",
            fontWeight: "700",
            fontSize: "clamp(28px, 7vw, 50px)",
            lineHeight: "100%",
            letterSpacing: "-0.06em",
          }}
        >
          TRUNG TÂM KHUYẾN MÃI
        </h1>
      </div> */}
      <div className="px-0">
        <div
          className="p-2 md:p-4 rounded-[15px] w-full flex flex-col gap-4 md:gap-5 md:h-[440px] "
          style={{
            background:
              "linear-gradient(180deg, rgba(255, 255, 255, 0.34) 0%, rgba(215, 236, 255, 0.42) 100%)",
            border: "4px solid rgba(255, 255, 255, 0.45)",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(12px)",
            boxShadow: "0px 4px 32px 0px rgba(3, 106, 124, 0.23)",
          }}
        >
          <div className="flex flex-col gap-4 md:gap-9 w-full transform md:translate-y-[10%]">
            <div className="w-full">
              <div className="flex items-center gap-4 mb-2">
                <img
                  src={iconUser}
                  alt="User"
                  className="w-auto h-auto md:w-auto md:h-auto object-contain shrink-0"
                />
                {/* <span className="text-[#4B4B4B] font-bold text-sm md:text-lg">
                  Tên tài khoản
                </span> */}
              </div>
              <input
                type="text"
                placeholder="Nhập thông tin "
                className="w-full h-12 md:h-14 px-4 md:px-5 rounded-xl md:rounded-2xl outline-none font-semibold text-[#006090] placeholder:text-[#7C8BA0] placeholder:opacity-100 placeholder:font-medium placeholder:text-xs md:placeholder:text-base text-sm md:text-base border border-[#5B93FF] shadow-sm transition-all duration-300 focus:border-[#55D2FF] focus:ring-4 focus:ring-[#55D2FF]/20"
                style={{
                  background:
                    "linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(232, 243, 255, 0.98) 100%)",
                  backdropFilter: "blur(6px)",
                  WebkitBackdropFilter: "blur(6px)",
                }}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            {/* <div className="w-full">
              <div className="flex items-center gap-2 mb-2">
               <img
                  src={iconInfo}
                  alt="Info"
                  className="w-auto h-auto md:w-auto md:h-auto object-contain shrink-0"
                />
              
              </div>
              <div className="relative">
                <select
                  defaultValue="llw58k"
                  className="w-full h-12 md:h-14 pl-[92px] pr-10 rounded-xl md:rounded-2xl outline-none font-semibold text-[#2F80FF] text-sm md:text-base border border-[#5B93FF] shadow-sm appearance-none transition-all duration-300 focus:border-[#55D2FF] focus:ring-4 focus:ring-[#55D2FF]/20"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(232, 243, 255, 0.98) 100%)",
                    backdropFilter: "blur(6px)",
                    WebkitBackdropFilter: "blur(6px)",
                  }}
                >
                  <option value="llw58k">Thành Viên Mới Tặng 58K</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 left-3 flex items-center">
                  <span className="min-w-[72px] h-7 px-3 rounded-full bg-[#2F80FF] text-white text-[11px] md:text-xs font-bold flex items-center justify-center shadow-sm">
                    LLW58K
                  </span>
                </div>
                <div className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-[#6B7280]">
                  <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>
            </div> */}

            <div className="w-full">
              <div className="flex items-center gap-2 mb-2">
                <img
                  src={iconTick}
                  alt="Tick"
                  className="w-auto h-auto md:w-auto md:h-auto object-contain shrink-0"
                />
                {/* <span className="text-[#4B4B4B] font-bold text-sm md:text-lg">
                  Xác thực
                </span> */}
              </div>
              <div className="flex items-center gap-2 md:gap-3">
                <input
                  type="text"
                  placeholder="Nhập mã captcha"
                  className="flex-1 h-12 md:h-14 px-4 md:px-5 rounded-xl md:rounded-2xl outline-none font-semibold text-[#006090] placeholder:text-[#7C8BA0] placeholder:opacity-100 placeholder:font-medium placeholder:text-xs md:placeholder:text-base text-sm md:text-base border border-[#5B93FF] shadow-sm transition-all duration-300 focus:border-[#55D2FF] focus:ring-4 focus:ring-[#55D2FF]/20"
                  style={{
                    background:
                      "linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(232, 243, 255, 0.98) 100%)",
                    backdropFilter: "blur(6px)",
                    WebkitBackdropFilter: "blur(6px)",
                  }}
                  value={captcha}
                  onChange={(e) => setCaptcha(e.target.value)}
                />
                {captchaSvg && (
                  <div
                    className="w-20 min-[361px]:w-24 md:w-28 h-12 md:h-14 cursor-pointer bg-white/80 rounded-xl md:rounded-2xl overflow-hidden flex items-center justify-center shadow-sm border border-[#5B93FF] shrink-0"
                    dangerouslySetInnerHTML={{ __html: captchaSvg }}
                    onClick={fetchCaptcha}
                  />
                )}
              </div>
            </div>

            <div className="flex justify-center pt-1 md:mt-8">
              <button
                className="min-w-32 md:min-w-40 h-11 md:h-12 px-8 rounded-full text-white font-extrabold text-sm md:text-base uppercase transition-all hover:scale-105 active:scale-95 flex items-center justify-center border-2 border-white"
                style={{
                  background: "#1678FF",
                  boxShadow: "0px 10px 24px 0px rgba(22, 29, 36, 0.16)",
                }}
                onClick={checkUsername}
              >
                Xác nhận
              </button>
            </div>
          </div>

          {/* ANNOUNCEMENT BAR (Bottom strip) */}
          {/* <div
            className="w-full h-10 md:h-12 rounded-xl flex items-center px-4 gap-3 text-white font-bold overflow-hidden"
            style={{
              background: "#00AEEF",
            }}
          >
            <div className="flex-shrink-0 flex items-center">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 5L6 9H2V15H6L11 19V5Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19.07 4.93C20.9447 6.80528 21.9979 9.34836 21.9979 12C21.9979 14.6516 20.9447 17.1947 19.07 19.07" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.54 8.46C16.4774 9.39763 17.0039 10.6692 17.0039 12C17.0039 13.3308 16.4774 14.6024 15.54 15.54" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="text-sm md:text-base whitespace-nowrap overflow-hidden font-black py-1">
              <div className="animate-[marquee_35s_linear_infinite] md:animate-[marquee_60s_linear_infinite] inline-block pl-[100%]">
                {titleNotify}
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
